/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Min_CharsInputs */

const en_domain_search_modal_min_chars = /** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter at least 2 characters (no extension needed)`)
};

const es_domain_search_modal_min_chars = /** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduce al menos 2 caracteres (sin extensión)`)
};

const fr_domain_search_modal_min_chars = /** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer au moins 2 caractères (pas besoin d'extension)`)
};

const de_domain_search_modal_min_chars = /** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib mindestens 2 Zeichen ein (keine Endung erforderlich)`)
};

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const ja_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const zh_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const ar_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const id_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const it_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const ru_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const pt_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/** @type {(inputs: Domain_Search_Modal_Min_CharsInputs) => LocalizedString} */
const ko_domain_search_modal_min_chars = en_domain_search_modal_min_chars;

/**
* | output |
* | --- |
* | "Please enter at least 2 characters (no extension needed)" |
*
* @param {Domain_Search_Modal_Min_CharsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_min_chars = /** @type {((inputs?: Domain_Search_Modal_Min_CharsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Min_CharsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_min_chars(inputs)
	if (locale === "es") return es_domain_search_modal_min_chars(inputs)
	if (locale === "fr") return fr_domain_search_modal_min_chars(inputs)
	if (locale === "de") return de_domain_search_modal_min_chars(inputs)
	if (locale === "ja") return ja_domain_search_modal_min_chars(inputs)
	if (locale === "zh") return zh_domain_search_modal_min_chars(inputs)
	if (locale === "ar") return ar_domain_search_modal_min_chars(inputs)
	if (locale === "id") return id_domain_search_modal_min_chars(inputs)
	if (locale === "it") return it_domain_search_modal_min_chars(inputs)
	if (locale === "ru") return ru_domain_search_modal_min_chars(inputs)
	if (locale === "pt") return pt_domain_search_modal_min_chars(inputs)
	return ko_domain_search_modal_min_chars(inputs)
});